export default __webpack_public_path__ + "static/media/r2.e20452ca.jpg";